import { PencilIcon } from '@ds/components'

import styles from './HeroMobileControls.module.css'

type THeroMobileEditButtonProps = {
    label: string
    onClick: () => void
}

/** Owner's third mobile control, in place of the like button. Shares the row's icon-button chrome. */
export const HeroMobileEditButton = ({ label, onClick }: THeroMobileEditButtonProps) => (
    <button
        type="button"
        className={styles.iconButton}
        aria-label={label}
        onClick={onClick}
        data-test="audio-hero-mobile-edit"
    >
        <PencilIcon className={styles.icon} width={32} height={32} />
    </button>
)
